module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    domProps: {
      "value": _vm.activeSource
    },
    on: {
      "change": _vm.sourceChanged
    }
  }, _vm._l((_vm.sources), function(source, id) {
    return _c('option', {
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(source.name))])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d5d2f83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select-source/SelectSource.vue
// module id = 87
// module chunks = 0